import { function_ABM_CON_Monedas_Leer } from '../../ABM/CONT/ABM_CON_Monedas';
import { function_ABM_IMP_PuntosFiscales_LeerPorTerminal } from '../../ABM/IMP/ABM_IMP_PuntosFiscales';
import { function_ABM_EEX_Clientes_Leer } from '../../ABM/EEX/ABM_EEX_Clientes';
import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_GETBinario, llamadaAPI_POST, llamadaAPI_POSTBinario, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI, ConversionarrayBufferToBase64 } from '../../Varios';

export const function_VEN_DocsVenta_Cabecera_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_Listar"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarComisiones = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarComisiones"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarComisiones/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarSoloClientesPropios = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarSoloClientesPropios"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarSoloClientesPropios/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            localStorage.getItem("IdPersona") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarPorCobrar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarPorCobrar"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarPorCobrar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarPercepcionesRealizadas = async (FechaDesde, FechaHasta, Where) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarPercepcionesRealizadas"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarPercepcionesRealizadas/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarConDetalles = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarConDetalles"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarConDetalles/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_Leer = async (IdDocVenta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_Leer"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorTipo = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorTipo"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorTipo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorSubtipo = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorSubtipo"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorSubtipo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticulo = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticulo"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorArticulo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloUMBasica = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloUMBasica"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorArticuloUMBasica/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloDisgregadoPorPlanta = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloDisgregadoPorPlanta"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorArticuloDisgregadoPorPlanta/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloUMBasicaDisgregadoPorPlanta = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloUMBasicaDisgregadoPorPlanta"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorArticuloUMBasicaDisgregadoPorPlanta/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZ = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZ"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorArticuloVZ/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZUMBasica = async (FechaDesde, FechaHasta, Where, WhereCliente, WhereDelivery, FiltroCuentaFinanciera) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZUMBasica"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarAgrupadoPorArticuloVZUMBasica/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where) + "/" +
            await TratamientoDeParametroParaURI(WhereCliente) + "/" +
            await TratamientoDeParametroParaURI(WhereDelivery) + "/" +
            await TratamientoDeParametroParaURI(FiltroCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarPorCliente = async (FechaDesde, FechaHasta, IdCliente) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarPorCliente"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/PorCliente/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ListarPorValidarSinCierreDeCajaPorTerminalSeleccionada = async (Terminal = -1) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ListarPorValidarSinCierreDeCajaPorTerminalSeleccionada"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ListarPorValidarSinCierreDeCajaPorTerminalSeleccionada/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            Terminal);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ComparacionADiaAnterior = async (FechaConsulta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ComparacionADiaAnterior"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ComparacionADiaAnterior/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaConsulta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Generar_JSON = async (IdDocVenta,
    Turno, IdUsuarioCreador,
    IdTipoDocVenta, IdCliente, Fecha, FEFecha, FechaVencimiento,
    NumeroFantasia, CodigoPuntoFiscal, Numero, CodigoMoneda, Cotizacion, CodigoMonedaReferente,
    ImporteBonificaciones, ImporteRecargos, Concepto, Observaciones, IdDocVentaReferente, CodigoCondicionVenta,
    IdProveedorDelivery, CodigoOperacionProveedorDelivery, CodigoResumenDePagoProveedorDelivery,
    CodigoMesa, CantidadComensales, IdProfesionalMozo, FechaAperturaDocumentoAbierto, FechaCierreDocumentoAbierto,
    ColeccionDetalles, ColeccionImpuestos, ColeccionImputacionesContable, ColeccionImputacionesCosteo, ColeccionProfesionalesACargo) => {
    const NombreFuncion = "function_VEN_DocsVenta_Generar_JSON";

    try {
        const totalImporteNetoDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteNetoTotal, 0);
        const totalImporteBonificacionesDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteBonificacionesTotal, 0);
        const totalImporteRecargosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteRecargosTotal, 0);
        const totalImporteSubTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteSubTotalTotal, 0);
        const totalImporteIVADetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteIVATotal, 0);
        const totalImporteImpuestosInternosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteImpuestosInternosTotal, 0);
        const totalImporteTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteTotalTotal, 0);
        const totalImporteTotalImpuestos = ColeccionImpuestos.reduce((total, detalle) => total + detalle.Importe, 0);
        const totalImporteTotalPostImpuestos = totalImporteTotalDetalles + totalImporteTotalImpuestos;

        let CotizacionMonedaReferente = 1;
        let ImporteTotalPostImpuestosMonedaReferente = totalImporteTotalPostImpuestos;

        if (!ImporteBonificaciones) {
            ImporteBonificaciones = 0
        }

        if (!ImporteRecargos) {
            ImporteRecargos = 0
        }

        if (!CodigoMonedaReferente) {
            CodigoMonedaReferente = CodigoMoneda
            CotizacionMonedaReferente = 1
        }
        else {
            const MonedaReferente = await function_ABM_CON_Monedas_Leer(CodigoMonedaReferente)
            CotizacionMonedaReferente = MonedaReferente.data[0].Cotizacion
            ImporteTotalPostImpuestosMonedaReferente = totalImporteTotalPostImpuestos / CotizacionMonedaReferente
        }

        const JSON = {
            IdDocVenta: IdDocVenta,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdTipoDocVenta: IdTipoDocVenta,
            IdCliente: IdCliente,
            Fecha: Fecha,
            FEFecha: FEFecha,
            FechaVencimiento: FechaVencimiento,
            NumeroFantasia: NumeroFantasia,
            CodigoPuntoFiscal: CodigoPuntoFiscal,
            Numero: Numero,
            FENumeroFantasia: NumeroFantasia,
            FECodigoPuntoFiscal: CodigoPuntoFiscal,
            FENumero: Numero,
            CodigoMoneda: CodigoMoneda,
            Cotizacion: Cotizacion,
            CodigoMonedaReferente: CodigoMonedaReferente,
            CotizacionMonedaReferente: CotizacionMonedaReferente,
            ImporteNeto: totalImporteNetoDetalles,
            ImporteBonificaciones: ImporteBonificaciones,
            ImporteRecargos: ImporteRecargos,
            ImporteBonificacionesItems: totalImporteBonificacionesDetalles,
            ImporteRecargosItems: totalImporteRecargosDetalles,
            ImporteTotal: totalImporteTotalDetalles,
            ImporteTotalPostImpuestos: totalImporteTotalPostImpuestos,
            ImporteRecibido: 0,
            ImporteTotalPostImpuestosMonedaReferente: ImporteTotalPostImpuestosMonedaReferente,
            Concepto: Concepto,
            Observaciones: Observaciones,
            IdEstado: 240,
            IdDocVentaReferente: IdDocVentaReferente,
            CAEFechaObtencion: null,
            CAEFechaVencimiento: null,
            CAE: "",
            CAERazon: "",
            CAEMotivo: "",
            CAEFechaInsert: null,
            CodigoCondicionVenta: CodigoCondicionVenta,
            Terminal: localStorage.getItem("Terminal"),
            Turno: Turno,
            IdProveedorDelivery: IdProveedorDelivery,
            CodigoOperacionProveedorDelivery: CodigoOperacionProveedorDelivery,
            CodigoResumenDePagoProveedorDelivery: CodigoResumenDePagoProveedorDelivery,
            CodigoMesa: CodigoMesa,
            CantidadComensales: CantidadComensales,
            IdProfesionalMozo: IdProfesionalMozo,
            CantidadMinutosConDocumentoAbierto: 0,
            FechaAperturaDocumentoAbierto: FechaAperturaDocumentoAbierto,
            FechaCierreDocumentoAbierto: FechaCierreDocumentoAbierto,
            IdUsuarioCreador: IdUsuarioCreador,
            Detalles: ColeccionDetalles.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            Impuestos: ColeccionImpuestos.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            ImputacionesContable: ColeccionImputacionesContable.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            ImputacionesCosteo: ColeccionImputacionesCosteo.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            ProfesionalesACargo: ColeccionProfesionalesACargo.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            }))
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_Insertar = async (DocVenta, BajaStockSinImportarDefinicionDeArticulo) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_Insertar";

    try {
        const docVentaResult = await llamadaAPI_POST("VEN_DocsVenta_Cabecera/InsertarCompleto/" +
            BajaStockSinImportarDefinicionDeArticulo,
            DocVenta);
        return docVentaResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_Modificar = async (DocVenta, BajaStockSinImportarDefinicionDeArticulo) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_Modificar";

    try {
        await llamadaAPI_PUT("VEN_DocsVenta_Cabecera/ModificarCompleto/" +
            BajaStockSinImportarDefinicionDeArticulo,
            DocVenta);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ReporteDocVenta = async (IdDocVenta, formato) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ReporteDocVenta";

    try {
        const resulData = await llamadaAPI_GETBinario("VEN_DocsVenta_Cabecera/GenerarDocumento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ReporteDocVenta_EnvioMail = async (IdDocVenta, turno, toEmail) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ReporteDocVenta_EnvioMail";

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/EnvioMail/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta + "/" +
            turno + "/" +
            await TratamientoDeParametroParaURI(toEmail));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_Clonar = async (IdDocVenta, IdUsuarioCreador, Fecha, FechaVencimiento) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_Clonar"

    try {
        const resulData = await llamadaAPI_POST("VEN_DocsVenta_Cabecera/Clonar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta + "/" +
            IdUsuarioCreador + "/" +
            Fecha + "/" +
            FechaVencimiento);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ClonarConIncremento = async (IdDocVenta, IdUsuarioCreador, Fecha, FechaVencimiento, IncrementoEnPorcentaje) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ClonarConIncremento"

    try {
        const resulData = await llamadaAPI_POST("VEN_DocsVenta_Cabecera/ClonarConIncremento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta + "/" +
            IdUsuarioCreador + "/" +
            Fecha + "/" +
            FechaVencimiento + "/" +
            IncrementoEnPorcentaje);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_GenerarNC = async (IdDocVenta, IdUsuarioCreador, Fecha, FechaVencimiento) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_GenerarNC"

    try {
        const resulData = await llamadaAPI_POST("VEN_DocsVenta_Cabecera/GenerarNC/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta + "/" +
            IdUsuarioCreador + "/" +
            Fecha + "/" +
            FechaVencimiento);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE = async (IdDocVenta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE"

    try {
        const resulData = await llamadaAPI_GET("ARCA/fe/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_MarcaParaValidacionAutonoma = async (IdDocVenta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_MarcaParaValidacionAutonoma"

    const JSON = {
        IdDocVenta: IdDocVenta,
        CodigoCompania: localStorage.getItem("CodigoCompania"),
        CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
        CodigoPlanta: localStorage.getItem("CodigoPlanta"),
    }

    try {
        const resulData = await llamadaAPI_PUT("VEN_DocsVenta_Cabecera/MarcaParaValidacionAutonoma/",
            JSON);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_ImpresionComandera = async (IdDocVenta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_ImpresionComandera"

    try {
        const resulData = await llamadaAPI_GET("VEN_DocsVenta_Cabecera/ImpresionComandera/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            localStorage.getItem("Terminal") + "/" +
            IdDocVenta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Cabecera_Eliminar = async (IdDocVenta) => {
    const NombreFuncion = "function_VEN_DocsVenta_Cabecera_Eliminar"

    try {
        const resulData = await llamadaAPI_PUT("VEN_DocsVenta_Cabecera/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdDocVenta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};